import { render, staticRenderFns } from "./InspectionRecordItemDrawer.vue?vue&type=template&id=6d9c946e&scoped=true&"
import script from "./InspectionRecordItemDrawer.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordItemDrawer.vue?vue&type=script&lang=js&"
import style0 from "./InspectionRecordItemDrawer.vue?vue&type=style&index=0&id=6d9c946e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9c946e",
  null
  
)

export default component.exports